import { useMemo } from 'react'
import type { TabMappings } from '@/views/PreSales/PreSalesGiveawayView/components/Tabs/GiveawayTabs/types'
import { GiveawayTabEnum } from '@/views/PreSales/PreSalesGiveawayView/config'

interface TabRefs {
  detailsContainerRef: React.RefObject<HTMLDivElement | null>
  faqContainerRef: React.RefObject<HTMLDivElement | null>
  prizesContainerRef: React.RefObject<HTMLDivElement | null>
}

export const useTabMappings = (refs: TabRefs): TabMappings =>
  useMemo(
    () => ({
      refs: {
        [GiveawayTabEnum.Details]: refs.detailsContainerRef,
        [GiveawayTabEnum.Faq]: refs.faqContainerRef,
        [GiveawayTabEnum.Prizes]: refs.prizesContainerRef,
      },
    }),
    [refs.detailsContainerRef, refs.faqContainerRef, refs.prizesContainerRef],
  )
